import { ErrorType } from '../../errors/errors.types.js';
import { upgradePrompt } from '../../store/alerts.js';

const showUpgradePrompt = (error) => {
  const errorType = typeof error === "string" ? error : typeof error === "object" && "detail" in error ? error.detail : typeof error === "object" && "message" in error ? error.message : typeof error === "object" && "type" in error ? error.type : void 0;
  switch (errorType) {
    case ErrorType.EXCEEDS_ITEM_LIMIT:
      upgradePrompt({
        id: "quota-items-limit",
        title: "Upgrade to store more than 1000 items"
      });
      return true;
    case ErrorType.EXCEEDS_STORAGE_LIMIT:
      upgradePrompt({
        id: "quota-storage-limit",
        title: "Upgrade to store more than 250mb"
      });
      return true;
    default:
      return false;
  }
};

export { showUpgradePrompt };
//# sourceMappingURL=showUpgradePrompt.js.map
